/**
 *
 * CheckboxField
 *
 */

import React from 'react';
import {
  StyledCheckbox,
  Label,
  Input,
  Indicator,
} from './styledComponents';

import InputValidator from 'components/InputValidator';

const Checkbox = ({ input, children }) => (
  <StyledCheckbox>
    <Label>
      <Input type='checkbox' {...input} />
      <Indicator />
    </Label>
    {children}
  </StyledCheckbox>
);

const CheckboxField = ({ input, label, meta: { touched, error, valid } }) => {
  const hasError = touched && error,
        isValid  = touched && valid;

  const toggleCheck = () => {
    input.onChange(!input.value);
  }

  return (
    <Checkbox input={input}>
      {label && <span onClick={toggleCheck}>{label}</span>}
      <InputValidator
        iconStyle={{margin: "-32px 0 0 22px"}}
        hasError={hasError}
        isValid={isValid}
      />
    </Checkbox>
  );
}

export default CheckboxField;



// WEBPACK FOOTER //
// ./src/components/CheckboxField/index.js